import { Badge, Button, Col, Modal, Row, Spinner } from "react-bootstrap";

export function ImportAlertModal({
  processResult,
  isImportAlertModalOpen,
  setIsImportAlertModalOpen,
  handleExportBatchDetails,
  exportingBatchId
}) {
  const processedCount = Number(processResult?.success ?? 0) + Number(processResult?.alert ?? 0);

  return (
    <Modal
      show={isImportAlertModalOpen}
      onHide={() => setIsImportAlertModalOpen(false)}
      backdrop="static"
      size="sm"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header className="justify-content-center">
        <Modal.Title id="example-custom-modal-styling-title">
          Atenção!
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col className="text-center">
            <span className="text-center">Há produtos que não foram processados ou processados com sinal de alerta.</span>
          </Col>
        </Row>
        <Col>
          <Row className="mt-3">
            <Col>
              <Badge bg="success" className="w-100 p-1">
                <h5>Processados: {processedCount}</h5>
              </Badge>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Badge bg="yellow" className="w-100 p-1">
                <h5>Alertas: {processResult.alert}</h5>
              </Badge>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Badge bg="orange" className="w-100 p-1">
                <h5>Não processados: {processResult.no_processed}</h5>
              </Badge>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Badge bg="danger" className="w-100 p-1">
                <h5>Erros: {processResult.error}</h5>
              </Badge>
            </Col>
          </Row>
        </Col>
        <Row className="justify-content-center mt-5">
          <Button
            type="button"
            variant="info"
            className="float-end"
            disabled={exportingBatchId !== null}
            onClick={() => handleExportBatchDetails(processResult.id_lote)}
          >
            {exportingBatchId === processResult.idlote ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  className="me-2"
                /> {" "}
                Exportando...
              </>
            ) : (
              <>
                <i className="fa fa-file-export mr-2" />
                Exportar
              </>
            )}
          </Button>
          <Button
            type="button"
            variant="secondary"
            className="ml-4"
            onClick={() => setIsImportAlertModalOpen(false)}
          >
            Fechar
          </Button>
        </Row>
      </Modal.Body>
    </Modal>
  )
}
